import { render, staticRenderFns } from "./ListItemFence.vue?vue&type=template&id=4815b559"
import script from "./ListItemFence.vue?vue&type=script&lang=js"
export * from "./ListItemFence.vue?vue&type=script&lang=js"
import style0 from "./ListItemFence.vue?vue&type=style&index=0&id=4815b559&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports